import { render, staticRenderFns } from "./TaskModuleRulesEnabled.vue?vue&type=template&id=725d5381&scoped=true"
import script from "./TaskModuleRulesEnabled.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesEnabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d5381",
  null
  
)

export default component.exports